import { c as _c } from "react/compiler-runtime";
import { useSubscribedCoupon } from './useSubscribedCoupon.js';
/**
 * Returns the number of events for a given coupon and board index.
 *
 * @param root0 - The arguments including coupon identifiers and board index.
 * @param root0.couponId - The unique identifier for the coupon.
 * @param root0.couponIndex - The index of the current coupon.
 * @param root0.boardIndex - The index of the board of the current coupon.
 * @returns The number of events for the specified coupon and board.
 */
export function useCouponEventCount(t0) {
  const $ = _c(6);
  const {
    couponId,
    couponIndex,
    boardIndex
  } = t0;
  let t1;
  if ($[0] !== boardIndex) {
    t1 = coupon => {
      const board = coupon?.boards[boardIndex];
      if (!board) {
        return 0;
      }
      return board.outcomes.length;
    };
    $[0] = boardIndex;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== couponId || $[3] !== couponIndex || $[4] !== t1) {
    t2 = {
      couponId,
      couponIndex,
      selector: t1
    };
    $[2] = couponId;
    $[3] = couponIndex;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const eventCount = useSubscribedCoupon(t2);
  return eventCount;
}